module.exports = __webpack_public_path__ + "static/media/21-1.746c851e.mp3";